import { configureStore, Action } from "@reduxjs/toolkit";
import thunk, { ThunkAction } from "redux-thunk";

import rootReducer, { RootState } from "./rootReducer";

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export const sintesoStore = configureStore({
  reducer: rootReducer,
  middleware: [thunk]
});

export type AppDispatch = typeof sintesoStore.dispatch;
